import * as React from 'react';

const SvgComponent = _props => {
  const {'aria-label': ariaLabel, role, alt, ...rest} = _props;
  const props = {
    ...rest,
    ...(ariaLabel || alt
      ? {
          role: role || 'img',
          'aria-label': ariaLabel,
          alt
        }
      : {
          'aria-hidden': 'true'
        })
  };
  return (
    <svg
      id="prefix__Calque_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 24 24"
      xmlSpace="preserve"
      {...props}
    >
      <style>{'.prefix__st0{fill:currentColor}'}</style>
      <g fill="none" fillRule="evenodd">
        <path className="prefix__st0" d="M2.7 21.3V0H0v22.7c0 .7.6 1.3 1.3 1.3H24v-2.7H2.7z" />
        <path
          className="prefix__st0"
          d="M10.7 12.6l3.1 3.1c.5.5 1.4.5 1.9 0l8-8-1.9-1.9-7.1 7.1-3.1-3.1c-.5-.5-1.4-.5-1.9 0l-5.3 5.3L6.3 17l4.4-4.4z"
        />
      </g>
    </svg>
  );
};

export default SvgComponent;
